import React from 'react'

import { MobileContainer } from './mobile-container'
import { DesktopContainer } from './desktop-container'

export const MenuV2 = ({ isMobile }) => {
  return <>{isMobile ? <MobileContainer /> : <DesktopContainer />}</>
}
